// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"4618780c","305":"99afc42f","311":"715eb5ff","379":"fd4e6772","482":"f07c15e3","485":"ed3f36f3","545":"542e4e37","724":"7c97894f","921":"9aab9b3b","975":"a7a8ec10","997":"7043bd9b"}[chunkId] + ".chunk.js";
};